export const locales = {
  enCA: 'en-CA',
  zhHans: 'zh-Hans', // simplified
  zhHant: 'zh-Hant', // traditional
};

export const DEFAULT_REGION = 'ON';
